const isBrowserSide = typeof window !== 'undefined';

const getSelectorPartWithAllOptions = options =>
  Object.keys(options)
    .map(key => `[${key}="${options[key]}"]`)
    .join('');

const setHeadElement = (element, options) => {
  if (isBrowserSide) {
    let selector;
    let domEl;
    let needsAppend = false;
    if (element === 'title') {
      selector = 'title';
    } else if (element === 'meta') {
      // property="article:tag" can appear multiples times, so we must use all options to find them
      let selectorPart;
      if (options.property === 'article:tag') {
        selectorPart = getSelectorPartWithAllOptions(options);
      } else {
        selectorPart = options.property
          ? `[property="${options.property}"]`
          : `[name="${options.name}"]`;
      }
      selector = `meta${selectorPart}`;
    } else if (element === 'link') {
      // rel="preload" can appear multiples times, so we must use all options to find them
      let selectorPart;
      if (options.rel === 'preload') {
        selectorPart = getSelectorPartWithAllOptions(options);
      } else {
        selectorPart = `[rel="${options.rel}"]`;
      }
      selector = `link${selectorPart}`;
    } else if (element === 'script') {
      selector = `script[type="${options.type}"]`;
    }
    // Ensure we only select elements created by ourselves.
    domEl = document
      .getElementsByTagName('head')[0]
      .querySelector(`${selector}[data-head="true"]`);

    if (!domEl) {
      domEl = document.createElement(element);
      needsAppend = true;
    }

    domEl.dataset.head = true;
    Object.keys(options).forEach(key => {
      if (key === 'innerHTML') {
        domEl.innerHTML = options[key];
      } else {
        domEl.setAttribute(key, options[key]);
      }
    });

    if (needsAppend) {
      document.getElementsByTagName('head')[0].appendChild(domEl);
    }
  }
};

let items = { title: undefined, meta: [], link: [], script: [] };

export const headService = {
  title: title => {
    items.title = title;
    setHeadElement('title', { innerHTML: title });
  },
  meta: options => {
    items.meta.push(options);
    setHeadElement('meta', options);
  },
  link: options => {
    items.link.push(options);
    setHeadElement('link', options);
  },
  removeLink: rel => {
    items.link = items.link.filter(l => l.rel !== rel);
    if (isBrowserSide) {
      document.querySelector(`link[rel="${rel}"][data-head="true"]`)?.remove();
    }
  },
  script: options => {
    items.script.push(options);
    setHeadElement('script', options);
  },
  getTitle: () => items.title,
  getMeta: () => items.meta,
  getLink: () => items.link,
  getScript: () => items.script,
  reset: () => {
    items.title = undefined;
    items.meta = [];
    items.link = [];
    items.script = [];
    if (isBrowserSide) {
      document
        .getElementsByTagName('head')[0]
        .querySelectorAll('[data-head="true"]')
        .forEach(el => el.remove());
    }
  }
};
